<template>
  <div class="section">
    <div class="container">
      <div class="content">
        <!-- block brief -->
        <div class="columns">
          <!-- hash -->
          <div class="column is-four-fifths">
            <div>
              <div class="menu-label is-size-6">
                <span class="fa fa-cube"></span>
                <span>{{ $t("block.block") }}</span>
              </div>
              <code class="is-size-6 has-text-weight-bold">
                {{ $route.params.hash }}
              </code>
            </div>
          </div>
        </div>
        <!-- details -->
        <br>
        <br>
        <table class="table">
          <tbody>
          <tr>
            <td>{{ $t("table.date") }}</td>
            <td> {{ $utils.formatTimestamp(block.timestamp) }}</td>
          </tr>
          <tr>
            <td>{{ $t("table.difficulty") }}</td>
            <td><code>{{ block.difficulty }}</code></td>
          </tr>
          <tr>
            <td>{{ $t("table.extra_data") }}</td>
            <td><code>{{ block.extra_data }}</code></td>
          </tr>
          <tr>
            <td>{{ $t("table.gas_limit") }}</td>
            <td><code>{{ block.gas_limit }}</code></td>
          </tr>
          <tr>
            <td>{{ $t("table.gas_used") }}</td>
            <td><code>{{ block.gas_used }}</code></td>
          </tr>
          <tr>
            <td>{{ $t("table.number") }}</td>
            <td><code>{{ block.number }}</code></td>
          </tr>
          <tr>
            <td>{{ $t("table.nonce") }}</td>
            <td><code>{{ block.nonce || 0 }}</code></td>
          </tr>
          <tr>
            <td>{{ $t("table.parent") }}</td>
            <td>
              <a v-bind:href="'#/block/'+ $utils.formatHash(block.parent_hash)">
                <code class="has-text-info">{{ $utils.formatHash(block.parent_hash) }}</code>
              </a>
            </td>
          </tr>
          <tr>
            <td>{{ $t("table.size") }}</td>
            <td><code>{{ block.size }}</code></td>
          </tr>
          </tbody>
        </table>
        <!-- completed transactions-->
        <br>
        <h4>{{ $t("block.transactions", {count: transactionCount}) }}</h4>
        <!-- transaction table -->
        <block-transaction-table :transactions="transactions"></block-transaction-table>
        <!-- json -->
        <br>
        <h2>{{ $t("res.json_rep") }}</h2>
        <blockquote>
          <code class="breakable">{{ json }}</code>
        </blockquote>
      </div>
    </div>
  </div>
</template>

<script>
  import BlockTransactionTable from '../components/layout/BlockTransactionTable'

  export default {
    name: 'Block',
    components: {BlockTransactionTable},
    mounted () {
      this.$store.dispatch('loadBlock', this.$route.params.hash)
    },
    watch: {
      '$route.params.hash': function (hash) {
        this.$store.dispatch('loadBlock', this.$route.params.hash)
      }
    },
    computed: {
      block () {
        return this.$store.state.block
      },
      transactions () {
        const a = this.$store.state.block
        if (a && a.transactions) {
          return a.transactions
        } else {
          return []
        }
      },
      transactionCount () {
        const a = this.$store.state.block
        if (a && a.transactions) {
          return a.transactions.length
        } else {
          return 0
        }
      },
      json () {
        return JSON.stringify(this.$store.state.block, undefined, 2)
      }
    }
  }
</script>

<style lang="scss" scoped>
  blockquote {
    padding: 16px;
    border-left: none;
    margin: 0;
  }

  code.breakable {
    word-break: break-all;
    white-space: pre-wrap;
    padding: 0;
  }

  table {
    width: 100%;
  }

  td:first-child {
    width: 16%;
  }

  code {
    word-break: break-all;
    text-overflow: ellipsis;
  }
</style>



// WEBPACK FOOTER //
// src/views/Block.vue